<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Subscribed / Unsubscribed Doctor List</label>
</div>
<div class="col-md-12 mt-3">
  <div class="row col-md-12 justify-content-end mb-2">
    <button class="btn blueHeader button mr-4" (click)="resetPassword()"><em class="fa fa-key"
        *ngIf="isEditEnabled"></em>&nbsp;&nbsp;&nbsp;
      Hard Reset Pasword</button>
    <button class="btn btn-success button" (click)="exportAsXLSX()"><em class="fa fa-share"
        *ngIf="isEditEnabled"></em>&nbsp;&nbsp;&nbsp;
      Export to Excel</button>
  </div>
  <div class="table-responsive pl-10 pr-10">
    <table class="table table-hover table-bordered">
      <thead class="turTable">
        <tr class="">
          <th class="cellHeader text-center">Doctor Name</th>
          <th class="cellHeader text-center">Clinic Name</th>
          <!-- <th class="cellHeader">Registered / Activated</th> -->
          <th class="cellHeader text-center dateWid">Trial End</th>
          <th class="cellHeader text-center">Plan</th>
          <th class="cellHeader text-center dateWid">Payment Date</th>
          <th class="cellHeader text-center">Amount Paid <em class="text-warning fa fa-info-circle"
              title="Amount Paid (With Tax)"></em></th>
          <th class="cellHeader text-center dateWid">End Date</th>
          <th class="cellHeader text-center">Status</th>
          <th class="cellHeader text-center">Active / Max Doctor <em class="text-warning fa fa-info-circle"
              title="Total active Doctor/Max limit"></em></th>
          <th class="cellHeader text-center action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of subscriptionList">
          <td class="cellValue">{{item?.doctor?.first_name}} {{item?.doctor?.last_name}}</td>
          <td class="cellValue">{{item?.clinics[0].clinic?.name}}</td>
          <!-- <td class="cellValue"></td> -->
          <td class="cellValue text-right">{{item?.trail_period_end | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue text-right">{{item?.plan?.name}}</td>
          <td class="cellValue  text-center">{{item?.payment_details?.payment_date | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue text-center">&#8377; {{item?.paid_amount}}</td>
          <td class="cellValue  text-center">{{item?.subscription_end | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue text-center">{{item?.status}}</td>
          <td class="cellValue text-center">{{item?.active_doctors}}/{{item?.max_doctors}}
            <span class="fa fa-pencil-square-o editIcon" title="Edit" *ngIf="item.plan.name === 'PROFESSIONAL'"
              (click)="editMaxDoctor(item)"></span>
          </td>
          <td class="cellValue">
            <button class="invoiceTur btn" (click)="viewSubscription(item)">View</button>
            <button class="payBlue btn" (click)="editSubscription(item)" *ngIf="isEditEnabled">Edit</button>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent($event)">
  </mat-paginator>

</div>
